/* eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';

import './AspectRatioBox.scss';

const AspectRatioBox = ({ aspectRatio, children }) => {
	const { width, height } = aspectRatio;
	return (
		<div className={`aspect-ratio-${width}-${height}`}>
			<div className="aspect-ratio-box-inner-wrapper">{children}</div>
		</div>
	);
};

AspectRatioBox.propTypes = {
	aspectRatio: PropTypes.shape({})
};

export default AspectRatioBox;
